import { RootState } from '../store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { produce } from 'immer';
import { SoundOptions } from '../../shell/Sound';

export interface TSoundINT {
    url: string;
    key?: string,
    options?: SoundOptions;

}
export interface TsoundsINT {
    sound: TSoundINT[],
}


const soundsSlice = createSlice({
    name: 'sounds',
    initialState: { sound: [] } as TsoundsINT,
    reducers: {
        setSound(state, { payload }: PayloadAction<TSoundINT>) {
            return produce(state, draft => {
                if (!Array.isArray(draft.sound)) { draft.sound = []; }
                const index = draft.sound?.findIndex(s => {
                    return (s.key === payload.key);
                });
                if (index >= 0) {
                    if (payload.options?.shouldPlay === false) {

                        draft.sound.splice(index, 1);
                    } else {

                        draft.sound[index] = payload;
                    }
                } else {
                    draft.sound = [...draft.sound, payload];
                }

                // draft.lastUpdated = GameNames.SOUND;
            });
        },
        removeSound(state, { payload }: PayloadAction<string>) {
            return produce(state, draft => {
                if (!Array.isArray(draft.sound)) { draft.sound = []; }
                const index = draft.sound?.findIndex(s => {
                    return (s.key === payload);
                });
                if (index >= 0) {
                    draft.sound.splice(index, 1);
                }
                // draft.shouldStop = false;
            });
        },
    },

});

export const { setSound, removeSound } = soundsSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectSound = (state: RootState) => state.sounds;


export default soundsSlice.reducer;
